import AntBadge from 'antd/lib/badge';

export const Badge = AntBadge;
